import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../../../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../../../../CommonUtils/httpBodyOptions';
import { AgreementDTO, FirmSettingsDTO } from '../../../api/useFirmSettingsQuery';
import { queryKeys as firmSettingsQueryKeys } from '../../../api/queryKeys';
import { queryKeys as mySettingsQueryKeys } from '../../../../MySettings/api/queryKeys';
import { MySettingsDTO } from '../../../../MySettings/api/useMySettingsQuery';

interface AddAgreementsParams {
  isFirm?: boolean;
  agreements: { file: string; fileSize: number }[];
}

interface AddAgreementsMutationParams {
  isFirm?: boolean;
}

export const useAddAgreementsMutation = ({ isFirm }: AddAgreementsMutationParams) => {
  const queryClient = useQueryClient();

  const queryKey = isFirm ? firmSettingsQueryKeys.firmSettings() : mySettingsQueryKeys.mySettings();

  return useMutation(
    ({ agreements }: AddAgreementsParams): Promise<AgreementDTO[]> => {
      return authFetch(`/Adviser/Settings/${isFirm ? 'FirmAgreement' : 'MyAgreement'}`, {
        method: 'PUT',
        ...httpBodyOptions(agreements, true),
      });
    },

    {
      onSuccess(agreements) {
        queryClient.setQueryData<FirmSettingsDTO | MySettingsDTO | undefined>(queryKey, old => {
          return old
            ? {
                ...old,
                agreements: [...old.agreements, ...agreements],
              }
            : old;
        });
      },
    },
  );
};
